import { createContext, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import isEmpty from "lodash/isEmpty";
import axios from "../axios";

export const SystemStatusContext = createContext(undefined);

export const SystemStatusProvider = ({ children }) => {
  const [statuses, setStatuses] = useState({});
  const user = useSelector((state) => state?.auth?.user);
  const isAuthenticated = !isEmpty(user);

  const fetchStatuses = () => {
    axios
      .get("system-statuses")
      .then((response) => setStatuses(response.data))
      .catch((error) => console.error("Error fetching statuses:", error));
  };

  useEffect(() => {
    if (isAuthenticated) {
      fetchStatuses();
    }
  }, [isAuthenticated]);

  const contextValue = useMemo(() => ({ statuses, fetchStatuses }), [statuses]);

  return <SystemStatusContext.Provider value={contextValue}>{children}</SystemStatusContext.Provider>;
};
